import React, { useState, useEffect } from 'react';
import { notification } from '../../hocs/notification';
import axios from 'axios';
import { mainurl } from '../../../Mainurl';

import {
    Row, Col, Card, CardBody, CardHeader,
    Form, FormGroup, Input, Label,
    Button
} from 'reactstrap';

const AddUser = ({ back, reset }) => {

    const [userId, setUserId] = useState('');
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [mobileNo, setMobileNo] = useState('');
    const [role, setRole] = useState('0');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');

    const [stateName, setStateName] = useState('');
    const [stateOptions, setStateOptions] = useState([]);
    const [roleOpt, setRoleOpt] = useState([]);

    const passwordValid = password === confirmPassword && password !== '';

    // ✅ Load Roles
    useEffect(() => {

        let postData = [{ org_id: sessionStorage.getItem('org_id') }];

        axios({
            method: 'post',
            url: mainurl + 'Master/box_role_list',
            data: postData,
            headers: { 'Content-Type': 'application/json' }
        })
            .then((response) => {
                setRoleOpt(response.data);
            })
            .catch(() => { });

        fetchStateByUserId();

    }, []);

    // ✅ Fetch States by User ID
    const fetchStateByUserId = () => {

        let postData = [{ user_id: sessionStorage.getItem('user_id') }];

        axios({
            method: 'post',
            url: mainurl + 'Master/get_state_list2',
            data: postData,
            headers: { 'Content-Type': 'application/json' }
        })
            .then((response) => {

                console.log("STATE API RESPONSE:", response.data);

                if (Array.isArray(response.data)) {

                    setStateOptions(response.data);

                    if (response.data.length > 0) {
                        setStateName(response.data[0].state_name);
                    }

                } else {
                    setStateOptions([]);
                    setStateName('');
                }

            })
            .catch(() => {
                notification({
                    message: "State not found!",
                    type: 'error'
                })();
            });
    };

    // ✅ Add User
    const add_handler = (e) => {
        e.preventDefault();

        if (!passwordValid) {
            notification({ message: "Passwords do not match!", type: 'warn' })();
            return;
        }

        if (role === "0") {
            notification({ message: "Please select User Role!", type: 'warn' })();
            return;
        }

        let postData = [{
            org_id: sessionStorage.getItem('org_id'),
            user_id: sessionStorage.getItem('user_id'),
            user_name: name,
            user_email: email,
            user_phone: mobileNo,
            role_code: role,
            password: password,
            state: stateName
        }];

        axios({
            method: 'post',
            url: mainurl + 'Master/box_user_add',
            data: postData,
            headers: { 'Content-Type': 'application/json' }
        })
            .then((response) => {

                let newUserId = response.data?.[0]?.retcode;

                notification({
                    message: "User added Successfully. User Id = " + newUserId,
                    type: 'info',
                    time: false,
                    position: 'center'
                })();

                reset();

            })
            .catch(() => {
                notification({
                    message: "Submit failed! Try Again",
                    type: 'error'
                })();
            });
    };

    return (
        <>
            <Card className='mb-3' color="primary" outline>
                <CardHeader>Add New User</CardHeader>
                <CardBody>
                    <Form onSubmit={add_handler}>
                        <Row>
                            {/* NAME */}
                            <FormGroup row>
                                <Label sm={2}>Name*</Label>
                                <Col sm={4}>
                                    <Input
                                        type='text'
                                        bsSize="sm"
                                        value={name}
                                        onChange={(e) => setName(e.target.value)}
                                        required
                                    />
                                </Col>
                            </FormGroup>

                            {/* EMAIL */}
                            <FormGroup row>
                                <Label sm={2}>Email*</Label>
                                <Col sm={4}>
                                    <Input
                                        type='email'
                                        bsSize="sm"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        required
                                    />
                                </Col>
                            </FormGroup>

                            {/* MOBILE */}
                            <FormGroup row>
                                <Label sm={2}>Mobile Number*</Label>
                                <Col sm={4}>
                                    <Input
                                        type='text'
                                        bsSize="sm"
                                        maxLength={10}
                                        pattern="[0-9]*"
                                        value={mobileNo}
                                        onChange={(e) => setMobileNo(e.target.value)}
                                        required
                                    />
                                </Col>
                            </FormGroup>

                            {/* STATE */}
                            <FormGroup row>
                                <Label sm={2}>State*</Label>
                                <Col sm={4}>
                                    <Input
                                        type="select"
                                        bsSize="sm"
                                        value={stateName}
                                        onChange={(e) => setStateName(e.target.value)}
                                        required
                                    >
                                        <option value="">--Select State--</option>

                                        {stateOptions.map((st, i) => (
                                            <option key={i} value={st.state_code}>
                                                {st.state_name}
                                            </option>
                                        ))}

                                    </Input>
                                </Col>
                            </FormGroup>

                            {/* ROLE */}
                            <FormGroup row>
                                <Label sm={2}>User Role*</Label>
                                <Col sm={4}>
                                    <Input
                                        type="select"
                                        bsSize="sm"
                                        value={role}
                                        onChange={(e) => setRole(e.target.value)}
                                    >
                                        <option value="0">--Select Role--</option>
                                        {roleOpt.map((row, i) => (
                                            <option key={i} value={row.role_code}>
                                                {row.role_desc}
                                            </option>
                                        ))}
                                    </Input>
                                </Col>
                            </FormGroup>

                            {/* PASSWORD */}
                            <FormGroup row>
                                <Label sm={2}>Password*</Label>
                                <Col sm={2}>
                                    <Input
                                        type='password'
                                        bsSize="sm"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        required
                                    />
                                </Col>
                                <Col sm={2}>
                                    <Input
                                        type='password'
                                        bsSize="sm"
                                        value={confirmPassword}
                                        onChange={(e) => setConfirmPassword(e.target.value)}
                                        valid={passwordValid}
                                        invalid={!passwordValid && confirmPassword !== ''}
                                        required
                                    />
                                </Col>
                            </FormGroup>

                            <Col md={2}>
                                <Button color='primary' size="sm" block>
                                    Submit
                                </Button>
                            </Col>

                        </Row>
                    </Form>
                </CardBody>
            </Card>

            <div className='text-end mt-3'>
                <Button color='primary' size="sm" onClick={back}>
                    Back
                </Button>
            </div>
        </>
    );
};

export default AddUser;
